<template>
  <div>
    <b-modal
      id="modal-noshow-booking"
      size="md"
      v-model="isOpen"
      centered
      hide-header
      :no-close-on-backdrop="true"
    >
      <b-card-header class="bg-linear-warning">
        <div class="d-flex justify-content-between align-items-center block-header">
          <h4 class="mb-0 text-warning">
            No-Show
          </h4>
          <ez-icon
            icon="ezGolf-icon-x"
            class="cursor-pointer"
            size="24"
            color="#FDB913"
            @click="hideModal"
          />
        </div>
      </b-card-header>
      <b-card-body>
        <div class="form">
          <div class="form-block">
            <b-form-group :label="$t('golf_noshow_reason')">
              <b-form-textarea
                v-model="reason"
                :placeholder="$t('golf_noshow_input_reason')"
                rows="2"
                no-resize
              />
            </b-form-group>
          </div>
        </div>
      </b-card-body>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="warning"
            size="md"
            class="float-right"
            @click="noShowBooking_UBK08"
          >
            {{ $t('golf_common_confirm') }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <ShortKey
      :shortcuts="ShortCutKey"
      :is-active="isOpen"
      :all-child-component-closed="allChildComponentClosed"
      @triggered="onTriggeredEventHandler"
    />
  </div>
</template>

<script>

import { booking } from '@/api/booking'
import {F1,F2,F3,F4,F5,F6,F7,F8,F9,F10,F11,F12,A,F,S} from '@/api/constant.js'
import ShortKey from '@/views/modules/ultils/ShortKey'
export default {
  components: {
    ShortKey
  },
  props: [
    'items', 'BookingDetailId',
  ],
  data() {
    return {
      reason: '',
      ShortCutKey : [F1,F2,F3,F4,F5,F6,F7,F8,F9,F10,F11,F12,A,F,S],
      allChildComponentClosed: [],
      isOpen: false
    }
  },
  watch: {
    isOpen(val) {
      this.$emit('is-open', {ComponentId: "modal-noshow-booking",IsActive:val});
    }
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('modal-noshow-booking')
    },
    async noShowBooking_UBK08() {
      let BookingDetail = []
      if (this.items.length) {
        // from lists
        this.items.forEach(x => {
          BookingDetail.push({
            Id: x.Id,
            Reasons: this.reason,
          })
        })
      } else {
        // from detail
        BookingDetail = [
          {
            Id: this.BookingDetailId,
            Reasons: this.reason,
          },
        ]
      }

      const dataRequest = {
        BookingDetail,
      }

      const response = await booking.noShow(dataRequest)
      this.showResToast(response)
      if (response.Status === '200') {
        this.$emit('event', { type: 'after-no-show' })
      }
      this.$nextTick(() => {
        this.$bvModal.hide('modal-noshow-booking')
      })
    },
    onTriggeredEventHandler(payload) {
      if (payload.evt.ctrlKey && payload.key === S) {
        this.noShowBooking_UBK08()
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
